import { cn } from "@repo/utils";

export default function ProjetHorairesVariables() {
  return (
    <>
      <img
        src="/logos/sytel_grand_est.png"
        alt="logo_sytel_grand_est"
        height={200}
        width={200}
      />
      <div className={cn("self-center text-2xl font-bold")}>
        {`PROJET D'HORAIRE VARIABLE`}
      </div>
      <img
        src="/images_pj/horaire_variable.png"
        alt="horaire_varible"
        height={280}
        width={700}
        className={cn("self-center")}
      />
      <div className={cn("space-y-6")}>
        <div>
          {`L' `}
          <span>amplitude</span>{" "}
          {`indique la
          durée quotidienne totale d'ouverture du service administratif
          (10heures).`}
        </div>
        <div>
          Les <span>plages fixes</span> sont les périodes où la présence de la
          totalité du personnel est obligatoire(4h30).
        </div>
        <div>
          Les <span>plages variables </span>{" "}
          {`sont
          les périodes où la présence de la totalité du personnel n'est pas
          obligatoire (5h30).`}
        </div>
        <div>
          Les <span>périodes de permanence</span> sont celles pendant lesquelles
          un service continu doit être assuré à la clientèle (7h30).
        </div>
      </div>
    </>
  );
}

ProjetHorairesVariables.title = "Projet d'horaires variables";
